'use client';

import { type ReactNode } from 'react';
import type { TransformedProcessData } from '@/types/process';
import '../process-animations.css';
import ProcessHero from '../components/ProcessHero';
import ProcessProgressBar from '../components/ProcessProgressBar';
import ProcessStagesList from '../components/ProcessStagesList';

interface OurProcesClientProps {
  locale: string;
  processData: TransformedProcessData;
  faqSlot?: ReactNode;
}

export default function OurProcesClient({ processData, faqSlot }: OurProcesClientProps) {
  return (
    <div
      data-section-blur="false"
      className="-mt-[calc(var(--site-header-height)+2px)] min-h-screen overflow-x-hidden bg-[#F0EDE8] lg:mt-0"
    >
      <ProcessProgressBar />
      <ProcessHero
        eyebrowTitle={processData.eyebrowTitle}
        descriptionHtml={processData.hero.descriptionHtml}
        bannerHeading={processData.hero.bannerHeading}
        processNav={processData.processNav}
      />
      <ProcessStagesList
        sequence={processData.sequence}
        processNav={processData.processNav}
        preFooter={processData.preFooter}
      />
      {faqSlot}
    </div>
  );
}
